import { styled } from '@mui/material/styles';

export const FooterRoot = styled('footer')(() => ({
  backgroundColor: '#2b5b94',
  color: '#fff',
  padding: '0.8em 0',
  width: '100%'
}));

export const FooterRow = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%'
});

export const FooterColumnL = styled('div')(({ theme }) => ({
  flex: 5,
  [theme.breakpoints.down('md')]: {
    flex: 2
  }
}));

export const FooterColumnR = styled('div')({
  flex: 1
});

export const FooterMenu = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column'
  }
}));

export const LinkTypography = styled('div')(({ theme }) => ({
  fontSize: '16px',
  margin: '0 1rem',
  fontWeight: 500,
  textTransform: 'uppercase',
  '& a': {
    color: '#fff',
    textDecoration: 'none'
  },
  [theme.breakpoints.down('md')]: {
    marginTop: '5px'
  }
}));

export const MarkdownText = styled('div')({
  '& a': {
    textDecoration: 'none',
    color: '#fff !important'
  },
  '& p': {
    margin: 0,
    textAlign: 'left',
    fontSize: '12px'
  }
});
